import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=140eda1c"
import script from "./carousel.ts?vue&type=script&lang=ts&external"
export * from "./carousel.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports